import {EditorState, StateEffect, StateField} from '@codemirror/state'
import {EditorView} from '@codemirror/view'
import {isMacOS} from '@github-ui/get-os'

/** Effect that will be triggered when Mod (Cmd on Mac, Ctrl for Linux and Windows) is pressed or lifted.*/
const modPressedChangeEffect = StateEffect.define<boolean>()

// TODO: use `ui-commands` everywhere one day
const platformModKey = isMacOS() ? 'Meta' : 'Ctrl'

const modKeyObserver = EditorView.domEventObservers({
  keydown(event, view) {
    // eslint-disable-next-line @github-ui/ui-commands/no-manual-shortcut-logic
    if (event.key === platformModKey && !isModPressed(view.state))
      view.dispatch({effects: modPressedChangeEffect.of(true)})
  },
  keyup(event, view) {
    // eslint-disable-next-line @github-ui/ui-commands/no-manual-shortcut-logic
    if (event.key === platformModKey && isModPressed(view.state))
      view.dispatch({effects: modPressedChangeEffect.of(false)})
  },
  blur(_, view) {
    if (isModPressed(view.state)) view.dispatch({effects: modPressedChangeEffect.of(false)})
  },
})

/** Field to store the mod key pressed state on the editor state. */
export const isModPressedField = StateField.define<boolean>({
  create: () => false,
  update: (prev, transaction) => transaction.effects.find(eff => eff.is(modPressedChangeEffect))?.value ?? prev,
  provide: () => [modKeyObserver],
})

/** Extension that tracks when the user is pressing the mod key in the editor. */
export const modPressedExtension = [isModPressedField]

/** Get the mod key state from the editor state. Throws an error if `modPressedExtension` is not installed. */
export function isModPressed(state: EditorState) {
  return state.field(isModPressedField)
}
